<div class="qcontainer" *ngIf="{ appointmentFilterDropdowns: appointmentFilterDropdowns$ | async} as data">
  <form fxLayout="column" id="appointmentFilterForm" [formGroup]="appointmentFilterForm">
    <div fxLayout="row">
      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Appointment From</mat-label>
          <input matInput autocomplete="off" [matDatepicker]="appointmentDateFromPicker" name="fromDate"
            formControlName="appointmentDateFrom" [max]="maxAppointmentDate" placeholder="MM/DD/YYYY">
          <mat-error *ngIf="appointmentFilterForm.get('appointmentDateFrom').errors">
            {{appointmentFilterForm.get('appointmentDateFrom').errors | inputError}}
          </mat-error>
          <mat-datepicker-toggle matSuffix [for]="appointmentDateFromPicker"></mat-datepicker-toggle>
          <mat-datepicker #appointmentDateFromPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Appointment To</mat-label>
          <input matInput autocomplete="off" [matDatepicker]="appointmentDateToPicker" placeholder="MM/DD/YYYY"
            name="toDate" formControlName="appointmentDateTo" [max]="maxAppointmentDate">
          <mat-error *ngIf="appointmentFilterForm.get('appointmentDateTo').errors">
            {{appointmentFilterForm.get('appointmentDateTo').errors | inputError}}</mat-error>
          <mat-datepicker-toggle matSuffix [for]="appointmentDateToPicker"></mat-datepicker-toggle>
          <mat-datepicker #appointmentDateToPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="form-field" *ngIf="appointmentFilterForm.errors">
      <mat-error>{{appointmentFilterForm.errors?.dates}}</mat-error>
    </div>

    <!-- Part of PL redesign, XS-3025, remove when finished START-->
    <!-- <div class="flex flex-row">
      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Service Code</mat-label>
          <mat-select formControlName="serviceCode">
            <mat-option>None</mat-option>
            <mat-option *ngFor="let sc of data.appointmentFilterDropdowns.serviceCodes | orderBy:['serviceCode']"
              [value]="sc.serviceCode">
              {{sc.serviceCode}} - {{sc.description}}
            </mat-option>
            <mat-select-trigger>
              {{ appointmentFilterForm.get('serviceCode').value}}
            </mat-select-trigger>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Ride Preference</mat-label>
          <mat-select formControlName="transportOptionId">
            <mat-option>None</mat-option>
            <mat-option
              *ngFor="let transportOption of data.appointmentFilterDropdowns.transportOptions | orderBy:['name']"
              [value]="transportOption.id">
              {{transportOption.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->
    <!-- Part of PL redesign, XS-3025, remove when finished -->
    <div class="form-field">
      <div class="flex place-content-between place-items-center">
        <span>Only My Appointments</span>
        <mat-slide-toggle matInput formControlName="myAppointmentsToggle">
        </mat-slide-toggle>
      </div>
    </div>
    <div class="flex flex-row place-content-center place-items-center button-container">
      <button id="apply-filters-button" type="button" mat-raised-button color="primary"
        (click)="apply(appointmentFilterForm.value)" [disabled]="appointmentFilterForm.invalid">Apply</button>
    </div>
  </form>
</div>